import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../shared/services/api.service';

@Component({
    selector: 'app-remote-access',
    templateUrl: './remote-access.component.html',
    styleUrls: ['./remote-access.component.scss'],
    standalone: false
})
export class RemoteAccessComponent implements OnInit {

  constructor(private api: ApiService, private route: ActivatedRoute) { }

  ngOnInit(): void {
  	this.route.params.subscribe(
  		res => {
  			this._loadCompany(res.company_name)
  		}
  	);
  }

  _loadCompany(name: string) {
  	this.api.show('companies', name, {}, {
  		collection: 'access_url'
  	}).subscribe(
  		res => {
  			location = res.company.access_url;
  		}
  	);
  }
}
